import clsx from 'clsx'
import {FC} from 'react'
import {useAuth} from '../../../auth'
import {openBusinessSwitcher, useCanSwitchBusiness} from './BusinessQuickSwitcher'
import {useCurrentBusiness} from './useCurrentBusiness'
import './BusinessChip.scss'
import {isStaff} from '../../../auth/core/staffAccess'

/**
 * The business this tab works in, always in the header (the user, 2026-10-26): its name or panel label, its code and
 * its colour; a click (or Ctrl+K) opens the quick switcher. A tab's business is its own, so two tabs can show two.
 * Not for the system administrator, who picks a business on the pages that follow it (no header switcher, 2026-10-05).
 */
export const BusinessChip: FC<{itemClassName?: string}> = ({itemClassName}) => {
  const {currentUser} = useAuth()
  const business = useCurrentBusiness()
  const canSwitch = useCanSwitchBusiness()
  // Staff work across businesses with the pages' own pickers, so the header carries no business chip.
  if (!currentUser || isStaff(currentUser) || !business) return null

  const content = (
    <>
      <span
        className='mp-business-chip__dot'
        style={{background: business.color}}
        aria-hidden='true'
      />
      <span className='mp-business-chip__text'>
        <span className='mp-business-chip__name'>{business.shortName}</span>
        {business.codeText && <span className='mp-business-chip__code'>{business.codeText}</span>}
      </span>
      {canSwitch && <i className='las la-angle-down mp-business-chip__caret' aria-hidden='true' />}
    </>
  )

  return (
    <div className={clsx('app-navbar-item', itemClassName)}>
      {canSwitch ? (
        <button
          type='button'
          className='mp-business-chip'
          style={{borderColor: business.color}}
          onClick={openBusinessSwitcher}
          aria-label={`کسب‌وکار این تب: ${business.display}؛ رفتن به کسب‌وکار دیگر (Ctrl+K)`}
          title={`${business.display}؛ رفتن به کسب‌وکار دیگر (Ctrl+K)`}
        >
          {content}
        </button>
      ) : (
        <div
          className='mp-business-chip mp-business-chip--static'
          style={{borderColor: business.color}}
          title={business.display}
        >
          {content}
        </div>
      )}
    </div>
  )
}
